import { gql } from '@apollo/client/core';
export const EVENT_FIELDS_MINIMAL = gql `
  fragment EventFieldsMinimal on Event {
    id
    name
    timezone
    startTime
    endTime
    doorTime
  }
`;
//# sourceMappingURL=Api.js.map